<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    [style]="{width: '500px'}"
    (onHide)="closeDialog()"
    [draggable]="false"
    [resizable]="false">

    <ng-template pTemplate="header">
        <h5 class="m-0" translate>order.lbl_patient_info</h5>
    </ng-template>

    <div class="patient-info-content">
        @if (patientCodes && patientCodes.length) {
        <p-table [value]="patientCodes" [showGridlines]="true" [stripedRows]="true" class="patient-table">
            <ng-template pTemplate="header">
                <tr>
                    <th class="serial-header" translate>lbl_serial_number</th>
                    <th class="patient-header" translate>patient.lbl_patient_id</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-patient let-rowIndex="rowIndex">
                <tr>
                    <td class="serial-cell">{{ rowIndex + 1 }}</td>
                    <td class="patient-cell">{{ patient }}</td>
                </tr>
            </ng-template>
        </p-table>
        } @else {
        <div class="no-patients">
            <app-no-result-found></app-no-result-found>
        </div>
        }
    </div>

    <ng-template pTemplate="footer">
        <p-button
            [label]="'lbl_close' | translate"
            (onClick)="closeDialog()"
            [outlined]="true">
        </p-button>
    </ng-template>
</p-dialog>